import { IsBoolean, IsDate, IsNumber, IsOptional } from 'class-validator';
import { BaseDto } from '../base.dto';
import { CurrencyDto } from '../currency.dto';
import { MerchantDto } from '../merchant.dto';
import { TenderedAmountEnum } from '../tenderedAmount.enum';

export class CurrencyExchangeRateDto extends BaseDto {

  @IsDate()
  effectiveFrom?: Date;

  @IsNumber()
  exchangeRate: number;

  @IsNumber()
  @IsOptional()
  sequence: number;

  @IsBoolean()
  @IsOptional()
  isActive: boolean;

  merchant: MerchantDto;
  fromCurrency: CurrencyDto;
  toCurrency: CurrencyDto;
  tenderAmountSelected?: TenderedAmountEnum;
}
